import styled from 'styled-components/macro';

import { PopupTextArea, ErrorMessage } from '../Popups.styles';

export const ValidationErrorMessage = styled(ErrorMessage)`
  margin-bottom: 5px;
`;

export const EscalateMessageTextArea = styled(PopupTextArea)`
  margin-top: 10px;
  border-radius: 4px;
  padding: 4px;
  height: 70px;
`;

export const EmailTextArea = styled(EscalateMessageTextArea)`
  height: 28px;
`;

export const StyledSubheading = styled.h4`
  font-size: 14px;
  display: block;
  text-align: center;
  margin-bottom: 10px;
`;
